export const EMAIL_VERIFICATION_REQUEST_DISABLED_MINUTES = 10;
